
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.ts'
export type * from './prismaNamespace.ts'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  ETLRun: 'ETLRun',
  User: 'User',
  TeamUser: 'TeamUser',
  UserSettings: 'UserSettings',
  ServiceUser: 'ServiceUser',
  ServiceUserAuth: 'ServiceUserAuth',
  Site: 'Site',
  SiteCustomer: 'SiteCustomer',
  Team: 'Team',
  SnapSiteConfig: 'SnapSiteConfig',
  TeamConfig: 'TeamConfig',
  PriceStrategyConfig: 'PriceStrategyConfig',
  LeadTimeConfig: 'LeadTimeConfig',
  PriceSegmentConfig: 'PriceSegmentConfig',
  CustomerTermsAdjustment: 'CustomerTermsAdjustment',
  MarketIndustryAdjustment: 'MarketIndustryAdjustment',
  LastTransactionAgeAdjustment: 'LastTransactionAgeAdjustment',
  LastGrossMarginAdjustment: 'LastGrossMarginAdjustment',
  Customer: 'Customer',
  CustomerDiscount: 'CustomerDiscount',
  CustomerDiscountToSite: 'CustomerDiscountToSite',
  DiscountPrice: 'DiscountPrice',
  Market: 'Market',
  MarketToSite: 'MarketToSite',
  MarketPrice: 'MarketPrice',
  CustomerContact: 'CustomerContact',
  ConfiguratorSnapshot: 'ConfiguratorSnapshot',
  Part: 'Part',
  PartSite: 'PartSite',
  RootQuote: 'RootQuote',
  Quote: 'Quote',
  QuoteLine: 'QuoteLine',
  QuoteLineQuantityBreak: 'QuoteLineQuantityBreak',
  QuoteLinePartOption: 'QuoteLinePartOption',
  Order: 'Order',
  OrderLine: 'OrderLine',
  PartCustomerPriceIncrease: 'PartCustomerPriceIncrease',
  Document: 'Document',
  QuoteDocument: 'QuoteDocument',
  SnapQuote: 'SnapQuote',
  SnapQuoteVersion: 'SnapQuoteVersion',
  SnapQuoteAssignment: 'SnapQuoteAssignment',
  SnapQuoteLineImport: 'SnapQuoteLineImport',
  SnapQuoteLine: 'SnapQuoteLine',
  SnapQuotePrice: 'SnapQuotePrice',
  SnapUnsupportedCalculationLog: 'SnapUnsupportedCalculationLog',
  SnapWorkOrder: 'SnapWorkOrder',
  SnapOperation: 'SnapOperation',
  SnapRequirement: 'SnapRequirement',
  PriceSegment: 'PriceSegment',
  SnapProductOption: 'SnapProductOption',
  AutoConfiguratorDataImport: 'AutoConfiguratorDataImport',
  AutoConfiguratorDataSet: 'AutoConfiguratorDataSet',
  AlphaQuote: 'AlphaQuote',
  AlphaQuoteLineImport: 'AlphaQuoteLineImport',
  AlphaQuoteLine: 'AlphaQuoteLine',
  AlphaQuotePrice: 'AlphaQuotePrice',
  ServiceCharge: 'ServiceCharge'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const ETLRunScalarFieldEnum = {
  uuid: 'uuid',
  model: 'model',
  erpDB: 'erpDB',
  etlRunTimestamp: 'etlRunTimestamp',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  success: 'success',
  totalRecords: 'totalRecords',
  recordsWithErrors: 'recordsWithErrors',
  recordsSucceeded: 'recordsSucceeded',
  fkViolations: 'fkViolations',
  stats: 'stats',
  triggerType: 'triggerType',
  triggerArgs: 'triggerArgs'
} as const

export type ETLRunScalarFieldEnum = (typeof ETLRunScalarFieldEnum)[keyof typeof ETLRunScalarFieldEnum]


export const UserScalarFieldEnum = {
  id: 'id',
  oid: 'oid',
  firstName: 'firstName',
  lastName: 'lastName',
  displayName: 'displayName',
  email: 'email',
  status: 'status',
  lastLogin: 'lastLogin',
  userSettingsId: 'userSettingsId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  role: 'role'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const TeamUserScalarFieldEnum = {
  teamUuid: 'teamUuid',
  userUuid: 'userUuid'
} as const

export type TeamUserScalarFieldEnum = (typeof TeamUserScalarFieldEnum)[keyof typeof TeamUserScalarFieldEnum]


export const UserSettingsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  phoneNumber: 'phoneNumber',
  mobilePhoneNumber: 'mobilePhoneNumber',
  signatureTitle: 'signatureTitle',
  emailQuoteToCustomer: 'emailQuoteToCustomer',
  visualUserName: 'visualUserName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserSettingsScalarFieldEnum = (typeof UserSettingsScalarFieldEnum)[keyof typeof UserSettingsScalarFieldEnum]


export const ServiceUserScalarFieldEnum = {
  id: 'id',
  systemCode: 'systemCode',
  serviceIdentifier: 'serviceIdentifier',
  name: 'name',
  contactEmail: 'contactEmail',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ServiceUserScalarFieldEnum = (typeof ServiceUserScalarFieldEnum)[keyof typeof ServiceUserScalarFieldEnum]


export const ServiceUserAuthScalarFieldEnum = {
  identifier: 'identifier',
  description: 'description',
  salt: 'salt',
  keyHash: 'keyHash',
  serviceUserId: 'serviceUserId',
  expirationDate: 'expirationDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ServiceUserAuthScalarFieldEnum = (typeof ServiceUserAuthScalarFieldEnum)[keyof typeof ServiceUserAuthScalarFieldEnum]


export const SiteScalarFieldEnum = {
  uuid: 'uuid',
  code: 'code',
  specialization: 'specialization',
  name: 'name',
  erpDB: 'erpDB',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  snapSiteConfigUuid: 'snapSiteConfigUuid'
} as const

export type SiteScalarFieldEnum = (typeof SiteScalarFieldEnum)[keyof typeof SiteScalarFieldEnum]


export const SiteCustomerScalarFieldEnum = {
  siteUuid: 'siteUuid',
  customerUuid: 'customerUuid'
} as const

export type SiteCustomerScalarFieldEnum = (typeof SiteCustomerScalarFieldEnum)[keyof typeof SiteCustomerScalarFieldEnum]


export const TeamScalarFieldEnum = {
  uuid: 'uuid',
  teamCode: 'teamCode',
  teamName: 'teamName',
  siteUuid: 'siteUuid',
  currentTeamConfigUuid: 'currentTeamConfigUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TeamScalarFieldEnum = (typeof TeamScalarFieldEnum)[keyof typeof TeamScalarFieldEnum]


export const SnapSiteConfigScalarFieldEnum = {
  uuid: 'uuid',
  active: 'active',
  useConfigurator: 'useConfigurator',
  useImportLineItems: 'useImportLineItems',
  consolidateImportedLineItems: 'consolidateImportedLineItems',
  useQuoteWonLossStatus: 'useQuoteWonLossStatus',
  defaultPartRequirementFixedCost: 'defaultPartRequirementFixedCost',
  sellingUnitOfMeasure: 'sellingUnitOfMeasure',
  decimalPlaces: 'decimalPlaces',
  leadTimeFormat: 'leadTimeFormat',
  productionDaysPerWeek: 'productionDaysPerWeek',
  transitDaysPerWeek: 'transitDaysPerWeek',
  planningDaysPerWeek: 'planningDaysPerWeek',
  defaultWonLossStatus: 'defaultWonLossStatus',
  partSpecTable: 'partSpecTable',
  showCostFieldsForFixedPriceStrategies: 'showCostFieldsForFixedPriceStrategies',
  enableUnsupportedCalculationsFlag: 'enableUnsupportedCalculationsFlag',
  partInsightsMaxDaysForRecent: 'partInsightsMaxDaysForRecent',
  partInsightsMaxDaysForInclusion: 'partInsightsMaxDaysForInclusion',
  partInsightsHighWinRate: 'partInsightsHighWinRate',
  partInsightsLowWinRate: 'partInsightsLowWinRate',
  partInsightsLastOrderGrossMarginThreshold: 'partInsightsLastOrderGrossMarginThreshold',
  partInsightsLeadTimeRangeLow: 'partInsightsLeadTimeRangeLow',
  partInsightsLeadTimeRangeHigh: 'partInsightsLeadTimeRangeHigh',
  partInsightsLeadTimeMaxDaysForInclusion: 'partInsightsLeadTimeMaxDaysForInclusion',
  partSearchVisible: 'partSearchVisible',
  partSearchField_user1_enabled: 'partSearchField_user1_enabled',
  partSearchField_user1_name: 'partSearchField_user1_name',
  partSearchField_user2_enabled: 'partSearchField_user2_enabled',
  partSearchField_user2_name: 'partSearchField_user2_name',
  partSearchField_user3_enabled: 'partSearchField_user3_enabled',
  partSearchField_user3_name: 'partSearchField_user3_name',
  partSearchField_user4_enabled: 'partSearchField_user4_enabled',
  partSearchField_user4_name: 'partSearchField_user4_name',
  partSearchField_user5_enabled: 'partSearchField_user5_enabled',
  partSearchField_user5_name: 'partSearchField_user5_name',
  partSearchField_user6_enabled: 'partSearchField_user6_enabled',
  partSearchField_user6_name: 'partSearchField_user6_name',
  partSearchField_user7_enabled: 'partSearchField_user7_enabled',
  partSearchField_user7_name: 'partSearchField_user7_name',
  partSearchField_user8_enabled: 'partSearchField_user8_enabled',
  partSearchField_user8_name: 'partSearchField_user8_name',
  partSearchField_user9_enabled: 'partSearchField_user9_enabled',
  partSearchField_user9_name: 'partSearchField_user9_name',
  partSearchField_user10_enabled: 'partSearchField_user10_enabled',
  partSearchField_user10_name: 'partSearchField_user10_name',
  partSearchField_productCode_enabled: 'partSearchField_productCode_enabled',
  partSearchField_commodityCode_enabled: 'partSearchField_commodityCode_enabled',
  partSearchField_inventory_enabled: 'partSearchField_inventory_enabled',
  partSearchField_customerPartId_enabled: 'partSearchField_customerPartId_enabled',
  partInsightsCrossSitePartIdVisible: 'partInsightsCrossSitePartIdVisible',
  partInsightsPartHistoryVisible: 'partInsightsPartHistoryVisible',
  partInsightsLeadTimeVisible: 'partInsightsLeadTimeVisible',
  partInsightsLastOrderGrossMarginVisible: 'partInsightsLastOrderGrossMarginVisible',
  duplicateQuoteVisible: 'duplicateQuoteVisible',
  alphaVisible: 'alphaVisible',
  searchExistingCustomerPartIdsVisible: 'searchExistingCustomerPartIdsVisible',
  sendImportFilesToVisual: 'sendImportFilesToVisual',
  importFileSizeLimitBytes: 'importFileSizeLimitBytes',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type SnapSiteConfigScalarFieldEnum = (typeof SnapSiteConfigScalarFieldEnum)[keyof typeof SnapSiteConfigScalarFieldEnum]


export const TeamConfigScalarFieldEnum = {
  uuid: 'uuid',
  active: 'active',
  daysUntilExpiration: 'daysUntilExpiration',
  daysUntilExpectedWin: 'daysUntilExpectedWin',
  quotePdfType: 'quotePdfType',
  quoteEmailSettings: 'quoteEmailSettings',
  quoteEmailTemplate: 'quoteEmailTemplate',
  quoteIdPrefix: 'quoteIdPrefix',
  alphaEmbedTeam: 'alphaEmbedTeam',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  forTeamUuid: 'forTeamUuid'
} as const

export type TeamConfigScalarFieldEnum = (typeof TeamConfigScalarFieldEnum)[keyof typeof TeamConfigScalarFieldEnum]


export const PriceStrategyConfigScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  priceStrategyType: 'priceStrategyType',
  snapSiteConfigUuid: 'snapSiteConfigUuid',
  enabled: 'enabled',
  allowFallback: 'allowFallback',
  discountCode: 'discountCode',
  marketCode: 'marketCode',
  targetContributionMargin: 'targetContributionMargin',
  quantityRange: 'quantityRange',
  targetGrossMargin: 'targetGrossMargin',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type PriceStrategyConfigScalarFieldEnum = (typeof PriceStrategyConfigScalarFieldEnum)[keyof typeof PriceStrategyConfigScalarFieldEnum]


export const LeadTimeConfigScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  leadTimeType: 'leadTimeType',
  weeks: 'weeks',
  nasPartWeeks: 'nasPartWeeks',
  defaultWeeks: 'defaultWeeks',
  shiftHours: 'shiftHours',
  bufferDays: 'bufferDays',
  moveDayRatio: 'moveDayRatio',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  priceStrategyConfigUuid: 'priceStrategyConfigUuid'
} as const

export type LeadTimeConfigScalarFieldEnum = (typeof LeadTimeConfigScalarFieldEnum)[keyof typeof LeadTimeConfigScalarFieldEnum]


export const PriceSegmentConfigScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  priceSegmentType: 'priceSegmentType',
  priceStrategyConfigUuid: 'priceStrategyConfigUuid',
  enabled: 'enabled',
  low: 'low',
  medium: 'medium',
  high: 'high',
  portalsAdjustment: 'portalsAdjustment',
  threshold: 'threshold',
  ltAdjustment: 'ltAdjustment',
  gteAdjustment: 'gteAdjustment',
  simple: 'simple',
  moderate: 'moderate',
  complex: 'complex',
  defaultAdjustment: 'defaultAdjustment',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type PriceSegmentConfigScalarFieldEnum = (typeof PriceSegmentConfigScalarFieldEnum)[keyof typeof PriceSegmentConfigScalarFieldEnum]


export const CustomerTermsAdjustmentScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  netDays: 'netDays',
  adjustment: 'adjustment',
  priceSegmentConfigUuid: 'priceSegmentConfigUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type CustomerTermsAdjustmentScalarFieldEnum = (typeof CustomerTermsAdjustmentScalarFieldEnum)[keyof typeof CustomerTermsAdjustmentScalarFieldEnum]


export const MarketIndustryAdjustmentScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  marketCode: 'marketCode',
  adjustment: 'adjustment',
  priceSegmentConfigUuid: 'priceSegmentConfigUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type MarketIndustryAdjustmentScalarFieldEnum = (typeof MarketIndustryAdjustmentScalarFieldEnum)[keyof typeof MarketIndustryAdjustmentScalarFieldEnum]


export const LastTransactionAgeAdjustmentScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  ageInDays: 'ageInDays',
  adjustment: 'adjustment',
  priceSegmentConfigUuid: 'priceSegmentConfigUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type LastTransactionAgeAdjustmentScalarFieldEnum = (typeof LastTransactionAgeAdjustmentScalarFieldEnum)[keyof typeof LastTransactionAgeAdjustmentScalarFieldEnum]


export const LastGrossMarginAdjustmentScalarFieldEnum = {
  uuid: 'uuid',
  sortOrder: 'sortOrder',
  margin: 'margin',
  adjustment: 'adjustment',
  priceSegmentConfigUuid: 'priceSegmentConfigUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type LastGrossMarginAdjustmentScalarFieldEnum = (typeof LastGrossMarginAdjustmentScalarFieldEnum)[keyof typeof LastGrossMarginAdjustmentScalarFieldEnum]


export const CustomerScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  customerId: 'customerId',
  name: 'name',
  attentionName: 'attentionName',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  countryCode: 'countryCode',
  phone: 'phone',
  email: 'email',
  billingName: 'billingName',
  billingAddress1: 'billingAddress1',
  billingAddress2: 'billingAddress2',
  billingCity: 'billingCity',
  billingState: 'billingState',
  billingPostalCode: 'billingPostalCode',
  billingCountryCode: 'billingCountryCode',
  industry: 'industry',
  salesRepId: 'salesRepId',
  termsId: 'termsId',
  termsNetType: 'termsNetType',
  termsNetDays: 'termsNetDays',
  termsDiscountType: 'termsDiscountType',
  termsDiscountDays: 'termsDiscountDays',
  termsDiscountPercent: 'termsDiscountPercent',
  termsDescription: 'termsDescription',
  freightTerms: 'freightTerms',
  companyId: 'companyId',
  discountCode: 'discountCode',
  marketCode: 'marketCode',
  erpDB: 'erpDB',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedByEtlAt: 'updatedByEtlAt'
} as const

export type CustomerScalarFieldEnum = (typeof CustomerScalarFieldEnum)[keyof typeof CustomerScalarFieldEnum]


export const CustomerDiscountScalarFieldEnum = {
  id: 'id',
  discountCode: 'discountCode',
  description: 'description',
  discountPercent: 'discountPercent',
  erpDB: 'erpDB',
  updatedByEtlAt: 'updatedByEtlAt'
} as const

export type CustomerDiscountScalarFieldEnum = (typeof CustomerDiscountScalarFieldEnum)[keyof typeof CustomerDiscountScalarFieldEnum]


export const CustomerDiscountToSiteScalarFieldEnum = {
  customerDiscountId: 'customerDiscountId',
  siteUuid: 'siteUuid'
} as const

export type CustomerDiscountToSiteScalarFieldEnum = (typeof CustomerDiscountToSiteScalarFieldEnum)[keyof typeof CustomerDiscountToSiteScalarFieldEnum]


export const DiscountPriceScalarFieldEnum = {
  id: 'id',
  qtyBreak1: 'qtyBreak1',
  qtyBreak2: 'qtyBreak2',
  qtyBreak3: 'qtyBreak3',
  qtyBreak4: 'qtyBreak4',
  qtyBreak5: 'qtyBreak5',
  qtyBreak6: 'qtyBreak6',
  qtyBreak7: 'qtyBreak7',
  qtyBreak8: 'qtyBreak8',
  qtyBreak9: 'qtyBreak9',
  qtyBreak10: 'qtyBreak10',
  unitPrice1: 'unitPrice1',
  unitPrice2: 'unitPrice2',
  unitPrice3: 'unitPrice3',
  unitPrice4: 'unitPrice4',
  unitPrice5: 'unitPrice5',
  unitPrice6: 'unitPrice6',
  unitPrice7: 'unitPrice7',
  unitPrice8: 'unitPrice8',
  unitPrice9: 'unitPrice9',
  unitPrice10: 'unitPrice10',
  defaultUnitPrice: 'defaultUnitPrice',
  partId: 'partId',
  discountCode: 'discountCode',
  erpDB: 'erpDB',
  siteId: 'siteId'
} as const

export type DiscountPriceScalarFieldEnum = (typeof DiscountPriceScalarFieldEnum)[keyof typeof DiscountPriceScalarFieldEnum]


export const MarketScalarFieldEnum = {
  id: 'id',
  marketCode: 'marketCode',
  description: 'description',
  currencyId: 'currencyId',
  marketRate: 'marketRate',
  erpDB: 'erpDB',
  updatedByEtlAt: 'updatedByEtlAt'
} as const

export type MarketScalarFieldEnum = (typeof MarketScalarFieldEnum)[keyof typeof MarketScalarFieldEnum]


export const MarketToSiteScalarFieldEnum = {
  marketId: 'marketId',
  siteUuid: 'siteUuid'
} as const

export type MarketToSiteScalarFieldEnum = (typeof MarketToSiteScalarFieldEnum)[keyof typeof MarketToSiteScalarFieldEnum]


export const MarketPriceScalarFieldEnum = {
  id: 'id',
  qtyBreak1: 'qtyBreak1',
  qtyBreak2: 'qtyBreak2',
  qtyBreak3: 'qtyBreak3',
  qtyBreak4: 'qtyBreak4',
  qtyBreak5: 'qtyBreak5',
  qtyBreak6: 'qtyBreak6',
  qtyBreak7: 'qtyBreak7',
  qtyBreak8: 'qtyBreak8',
  qtyBreak9: 'qtyBreak9',
  qtyBreak10: 'qtyBreak10',
  unitPrice1: 'unitPrice1',
  unitPrice2: 'unitPrice2',
  unitPrice3: 'unitPrice3',
  unitPrice4: 'unitPrice4',
  unitPrice5: 'unitPrice5',
  unitPrice6: 'unitPrice6',
  unitPrice7: 'unitPrice7',
  unitPrice8: 'unitPrice8',
  unitPrice9: 'unitPrice9',
  unitPrice10: 'unitPrice10',
  defaultUnitPrice: 'defaultUnitPrice',
  partId: 'partId',
  marketCode: 'marketCode',
  erpDB: 'erpDB'
} as const

export type MarketPriceScalarFieldEnum = (typeof MarketPriceScalarFieldEnum)[keyof typeof MarketPriceScalarFieldEnum]


export const CustomerContactScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  name: 'name',
  phone: 'phone',
  email: 'email',
  notes: 'notes',
  customerId: 'customerId',
  erpDB: 'erpDB',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedByEtlAt: 'updatedByEtlAt'
} as const

export type CustomerContactScalarFieldEnum = (typeof CustomerContactScalarFieldEnum)[keyof typeof CustomerContactScalarFieldEnum]


export const ConfiguratorSnapshotScalarFieldEnum = {
  id: 'id',
  form: 'form',
  description: 'description',
  customerPartId: 'customerPartId',
  siteUuid: 'siteUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  configurationUuid: 'configurationUuid',
  snapshotVersion: 'snapshotVersion',
  hasStaleData: 'hasStaleData'
} as const

export type ConfiguratorSnapshotScalarFieldEnum = (typeof ConfiguratorSnapshotScalarFieldEnum)[keyof typeof ConfiguratorSnapshotScalarFieldEnum]


export const PartScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  partId: 'partId',
  description: 'description',
  type: 'type',
  material: 'material',
  diagramUris: 'diagramUris',
  status: 'status',
  productCode: 'productCode',
  commodityCode: 'commodityCode',
  user1: 'user1',
  user2: 'user2',
  user3: 'user3',
  user4: 'user4',
  user5: 'user5',
  user6: 'user6',
  user7: 'user7',
  user8: 'user8',
  user9: 'user9',
  user10: 'user10',
  erpDB: 'erpDB',
  createdBySnap: 'createdBySnap',
  missingInErp: 'missingInErp',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tempModifyDateMwi: 'tempModifyDateMwi',
  tempModifyDateMwiSpr: 'tempModifyDateMwiSpr',
  tempModifyDateMwiFas: 'tempModifyDateMwiFas',
  updatedByEtlMwiAt: 'updatedByEtlMwiAt',
  updatedByEtlMwiSprAt: 'updatedByEtlMwiSprAt',
  updatedByEtlMwiFasAt: 'updatedByEtlMwiFasAt'
} as const

export type PartScalarFieldEnum = (typeof PartScalarFieldEnum)[keyof typeof PartScalarFieldEnum]


export const PartSiteScalarFieldEnum = {
  id: 'id',
  status: 'status',
  unitPrice: 'unitPrice',
  planningLeadtime: 'planningLeadtime',
  partId: 'partId',
  qtyOnHand: 'qtyOnHand',
  qtyInDemand: 'qtyInDemand',
  qtyAvailableForMRP: 'qtyAvailableForMRP',
  qtyOnOrder: 'qtyOnOrder',
  qtyAvailToIssue: 'qtyAvailToIssue',
  qtyCommitted: 'qtyCommitted',
  productComplexityRanking: 'productComplexityRanking',
  siteCode: 'siteCode',
  user1: 'user1',
  user2: 'user2',
  user3: 'user3',
  user4: 'user4',
  user5: 'user5',
  user6: 'user6',
  user7: 'user7',
  user8: 'user8',
  user9: 'user9',
  user10: 'user10',
  erpDB: 'erpDB',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  tempModifyDateMwi: 'tempModifyDateMwi',
  tempModifyDateMwiSpr: 'tempModifyDateMwiSpr',
  tempModifyDateMwiFas: 'tempModifyDateMwiFas',
  updatedByEtlMwiAt: 'updatedByEtlMwiAt',
  updatedByEtlMwiSprAt: 'updatedByEtlMwiSprAt',
  updatedByEtlMwiFasAt: 'updatedByEtlMwiFasAt'
} as const

export type PartSiteScalarFieldEnum = (typeof PartSiteScalarFieldEnum)[keyof typeof PartSiteScalarFieldEnum]


export const RootQuoteScalarFieldEnum = {
  uuid: 'uuid',
  quoteId: 'quoteId',
  quoteBuilderVersion: 'quoteBuilderVersion',
  siteUuid: 'siteUuid',
  visualQuoteUuid: 'visualQuoteUuid',
  snapQuoteUuid: 'snapQuoteUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdByServiceUuid: 'createdByServiceUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type RootQuoteScalarFieldEnum = (typeof RootQuoteScalarFieldEnum)[keyof typeof RootQuoteScalarFieldEnum]


export const QuoteScalarFieldEnum = {
  id: 'id',
  quoteId: 'quoteId',
  status: 'status',
  startDate: 'startDate',
  expireDate: 'expireDate',
  dueDate: 'dueDate',
  wonLossDate: 'wonLossDate',
  expectedWinDate: 'expectedWinDate',
  notes: 'notes',
  internalNotes: 'internalNotes',
  customerHeader: 'customerHeader',
  customerQuoteId: 'customerQuoteId',
  wonLossStatus: 'wonLossStatus',
  customerId: 'customerId',
  erpDB: 'erpDB',
  createdBySnap: 'createdBySnap',
  salesRepId: 'salesRepId',
  salesRepName: 'salesRepName',
  salesRepEmail: 'salesRepEmail',
  salesRepPhone: 'salesRepPhone',
  csrOid: 'csrOid',
  csrName: 'csrName',
  csrEmail: 'csrEmail',
  siteId: 'siteId',
  createdById: 'createdById',
  createdByServiceId: 'createdByServiceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedByEtlAt: 'updatedByEtlAt',
  tempStatusEffDateMwi: 'tempStatusEffDateMwi',
  tempStatusEffDateMwiSpr: 'tempStatusEffDateMwiSpr',
  tempStatusEffDateMwiFas: 'tempStatusEffDateMwiFas',
  updatedByEtlMwiAt: 'updatedByEtlMwiAt',
  updatedByEtlMwiSprAt: 'updatedByEtlMwiSprAt',
  updatedByEtlMwiFasAt: 'updatedByEtlMwiFasAt'
} as const

export type QuoteScalarFieldEnum = (typeof QuoteScalarFieldEnum)[keyof typeof QuoteScalarFieldEnum]


export const QuoteLineScalarFieldEnum = {
  id: 'id',
  customerPartId: 'customerPartId',
  externalId: 'externalId',
  lineNumber: 'lineNumber',
  quantity: 'quantity',
  status: 'status',
  description: 'description',
  automatedUnitPrice: 'automatedUnitPrice',
  automatedMargin: 'automatedMargin',
  automatedQuantity: 'automatedQuantity',
  qbv1AutomatedLeadTimeWeeks: 'qbv1AutomatedLeadTimeWeeks',
  changeReason: 'changeReason',
  unitPrice: 'unitPrice',
  baseUnitPrice: 'baseUnitPrice',
  unitServiceCost: 'unitServiceCost',
  unitLaborCost: 'unitLaborCost',
  unitBurdenCost: 'unitBurdenCost',
  unitMaterialCost: 'unitMaterialCost',
  calculatedUnitCost: 'calculatedUnitCost',
  qbv1LeadTimeWeeks: 'qbv1LeadTimeWeeks',
  note: 'note',
  rafFinishCode: 'rafFinishCode',
  rafFinishDescription: 'rafFinishDescription',
  rafPatchLockCode: 'rafPatchLockCode',
  quoteId: 'quoteId',
  erpDB: 'erpDB',
  partId: 'partId',
  partErpDb: 'partErpDb',
  finishedPartId: 'finishedPartId',
  historicalOrderLineId: 'historicalOrderLineId',
  createdById: 'createdById',
  createdByServiceId: 'createdByServiceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedByEtlAt: 'updatedByEtlAt',
  tempCreateDateMwi: 'tempCreateDateMwi',
  tempCreateDateMwiSpr: 'tempCreateDateMwiSpr',
  tempCreateDateMwiFas: 'tempCreateDateMwiFas',
  updatedByEtlMwiAt: 'updatedByEtlMwiAt',
  updatedByEtlMwiSprAt: 'updatedByEtlMwiSprAt',
  updatedByEtlMwiFasAt: 'updatedByEtlMwiFasAt'
} as const

export type QuoteLineScalarFieldEnum = (typeof QuoteLineScalarFieldEnum)[keyof typeof QuoteLineScalarFieldEnum]


export const QuoteLineQuantityBreakScalarFieldEnum = {
  id: 'id',
  breakNumber: 'breakNumber',
  automatedUnitPrice: 'automatedUnitPrice',
  automatedMargin: 'automatedMargin',
  quantity: 'quantity',
  unitPrice: 'unitPrice',
  baseUnitPrice: 'baseUnitPrice',
  unitServiceCost: 'unitServiceCost',
  unitLaborCost: 'unitLaborCost',
  unitBurdenCost: 'unitBurdenCost',
  unitMaterialCost: 'unitMaterialCost',
  quoteLineId: 'quoteLineId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type QuoteLineQuantityBreakScalarFieldEnum = (typeof QuoteLineQuantityBreakScalarFieldEnum)[keyof typeof QuoteLineQuantityBreakScalarFieldEnum]


export const QuoteLinePartOptionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  groupName: 'groupName',
  weight: 'weight',
  suboptionName: 'suboptionName',
  metadata: 'metadata',
  quoteLineId: 'quoteLineId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type QuoteLinePartOptionScalarFieldEnum = (typeof QuoteLinePartOptionScalarFieldEnum)[keyof typeof QuoteLinePartOptionScalarFieldEnum]


export const OrderScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  orderId: 'orderId',
  description: 'description',
  status: 'status',
  currency: 'currency',
  orderDate: 'orderDate',
  promiseDate: 'promiseDate',
  promiseDelDate: 'promiseDelDate',
  desiredShipDate: 'desiredShipDate',
  lastShippedDate: 'lastShippedDate',
  quoteId: 'quoteId',
  siteId: 'siteId',
  customerId: 'customerId',
  erpDB: 'erpDB',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedByEtlAt: 'updatedByEtlAt'
} as const

export type OrderScalarFieldEnum = (typeof OrderScalarFieldEnum)[keyof typeof OrderScalarFieldEnum]


export const OrderLineScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  lineNumber: 'lineNumber',
  orderQuantity: 'orderQuantity',
  unitPrice: 'unitPrice',
  sellingUM: 'sellingUM',
  leadTime: 'leadTime',
  desiredShipDate: 'desiredShipDate',
  promiseShipDate: 'promiseShipDate',
  promiseDelDate: 'promiseDelDate',
  lastShippedDate: 'lastShippedDate',
  firstShippedDate: 'firstShippedDate',
  status: 'status',
  quoteId: 'quoteId',
  quoteLineNumber: 'quoteLineNumber',
  orderId: 'orderId',
  erpDB: 'erpDB',
  partId: 'partId',
  customerPartId: 'customerPartId',
  hasCostData: 'hasCostData',
  invoicedQuantity: 'invoicedQuantity',
  totalBurdenCost: 'totalBurdenCost',
  totalInvoicedAmount: 'totalInvoicedAmount',
  totalLaborCost: 'totalLaborCost',
  totalMaterialCost: 'totalMaterialCost',
  totalServiceCost: 'totalServiceCost',
  createdByService: 'createdByService',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedByEtlMwiAt: 'updatedByEtlMwiAt',
  updatedByEtlMwiSprAt: 'updatedByEtlMwiSprAt',
  updatedByEtlMwiFasAt: 'updatedByEtlMwiFasAt',
  costsUpdatedByEtlMwiAt: 'costsUpdatedByEtlMwiAt',
  costsUpdatedByEtlMwiSprAt: 'costsUpdatedByEtlMwiSprAt',
  costsUpdatedByEtlMwiFasAt: 'costsUpdatedByEtlMwiFasAt',
  updatedByEtlAt: 'updatedByEtlAt',
  costsUpdatedByEtlAt: 'costsUpdatedByEtlAt'
} as const

export type OrderLineScalarFieldEnum = (typeof OrderLineScalarFieldEnum)[keyof typeof OrderLineScalarFieldEnum]


export const PartCustomerPriceIncreaseScalarFieldEnum = {
  id: 'id',
  partUuid: 'partUuid',
  customerUuid: 'customerUuid',
  dateOfMostRecentPriceIncrease: 'dateOfMostRecentPriceIncrease',
  orderLineId: 'orderLineId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PartCustomerPriceIncreaseScalarFieldEnum = (typeof PartCustomerPriceIncreaseScalarFieldEnum)[keyof typeof PartCustomerPriceIncreaseScalarFieldEnum]


export const DocumentScalarFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  fileType: 'fileType',
  type: 'type',
  bucketPath: 'bucketPath',
  visualPath: 'visualPath',
  visualDocumentId: 'visualDocumentId',
  quoteLineId: 'quoteLineId',
  snapQuoteVersionUuid: 'snapQuoteVersionUuid',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  snapOperationUuid: 'snapOperationUuid',
  alphaQuoteUuid: 'alphaQuoteUuid',
  alphaQuoteLineUuid: 'alphaQuoteLineUuid',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DocumentScalarFieldEnum = (typeof DocumentScalarFieldEnum)[keyof typeof DocumentScalarFieldEnum]


export const QuoteDocumentScalarFieldEnum = {
  documentUuid: 'documentUuid',
  quoteUuid: 'quoteUuid'
} as const

export type QuoteDocumentScalarFieldEnum = (typeof QuoteDocumentScalarFieldEnum)[keyof typeof QuoteDocumentScalarFieldEnum]


export const SnapQuoteScalarFieldEnum = {
  uuid: 'uuid',
  status: 'status',
  quoteId: 'quoteId',
  customerUuid: 'customerUuid',
  customerTermsNetType: 'customerTermsNetType',
  customerTermsNetDays: 'customerTermsNetDays',
  customerTermsDiscType: 'customerTermsDiscType',
  customerTermsDiscDays: 'customerTermsDiscDays',
  customerTermsDescription: 'customerTermsDescription',
  customerTermsDiscountPercent: 'customerTermsDiscountPercent',
  customerFreightTerms: 'customerFreightTerms',
  siteUuid: 'siteUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdByServiceUuid: 'createdByServiceUuid',
  deletedByUserUuid: 'deletedByUserUuid',
  createdByTeamUuid: 'createdByTeamUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  currentVersionUuid: 'currentVersionUuid',
  copiedFromUuid: 'copiedFromUuid',
  currentAssignmentUuid: 'currentAssignmentUuid'
} as const

export type SnapQuoteScalarFieldEnum = (typeof SnapQuoteScalarFieldEnum)[keyof typeof SnapQuoteScalarFieldEnum]


export const SnapQuoteVersionScalarFieldEnum = {
  uuid: 'uuid',
  sentAt: 'sentAt',
  name: 'name',
  address1: 'address1',
  address2: 'address2',
  address3: 'address3',
  state: 'state',
  city: 'city',
  country: 'country',
  zipcode: 'zipcode',
  contactName: 'contactName',
  contactPhone: 'contactPhone',
  contactEmail: 'contactEmail',
  salesRepId: 'salesRepId',
  salesRepName: 'salesRepName',
  salesRepEmail: 'salesRepEmail',
  salesRepPhone: 'salesRepPhone',
  csrOid: 'csrOid',
  csrName: 'csrName',
  csrEmail: 'csrEmail',
  daysUntilQuoteExpires: 'daysUntilQuoteExpires',
  daysUntilExpectedWin: 'daysUntilExpectedWin',
  specs: 'specs',
  notes: 'notes',
  wonLossStatus: 'wonLossStatus',
  discountCode: 'discountCode',
  marketCode: 'marketCode',
  customerQuoteId: 'customerQuoteId',
  createdByUserUuid: 'createdByUserUuid',
  createdByServiceUuid: 'createdByServiceUuid',
  deletedByUserUuid: 'deletedByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  snapQuoteUuid: 'snapQuoteUuid'
} as const

export type SnapQuoteVersionScalarFieldEnum = (typeof SnapQuoteVersionScalarFieldEnum)[keyof typeof SnapQuoteVersionScalarFieldEnum]


export const SnapQuoteAssignmentScalarFieldEnum = {
  uuid: 'uuid',
  snapQuoteUuid: 'snapQuoteUuid',
  assignerUuid: 'assignerUuid',
  assigneeUuid: 'assigneeUuid',
  source: 'source',
  message: 'message',
  assignedAt: 'assignedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SnapQuoteAssignmentScalarFieldEnum = (typeof SnapQuoteAssignmentScalarFieldEnum)[keyof typeof SnapQuoteAssignmentScalarFieldEnum]


export const SnapQuoteLineImportScalarFieldEnum = {
  uuid: 'uuid',
  importerId: 'importerId',
  snapQuoteVersionUuid: 'snapQuoteVersionUuid',
  documentUuid: 'documentUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt'
} as const

export type SnapQuoteLineImportScalarFieldEnum = (typeof SnapQuoteLineImportScalarFieldEnum)[keyof typeof SnapQuoteLineImportScalarFieldEnum]


export const SnapQuoteLineScalarFieldEnum = {
  uuid: 'uuid',
  lineNumber: 'lineNumber',
  specs: 'specs',
  priceStrategy: 'priceStrategy',
  leadTimeNotes: 'leadTimeNotes',
  snapQuoteVersionUuid: 'snapQuoteVersionUuid',
  partUuid: 'partUuid',
  serviceChargeUuid: 'serviceChargeUuid',
  customerPartId: 'customerPartId',
  finishedPartId: 'finishedPartId',
  snapWorkOrderUuid: 'snapWorkOrderUuid',
  initialMarginSource: 'initialMarginSource',
  lastWinOrderLineId: 'lastWinOrderLineId',
  leadTimeSuggestionStatus: 'leadTimeSuggestionStatus',
  suggestedPricesStatus: 'suggestedPricesStatus',
  automatable: 'automatable',
  priceAdjustment: 'priceAdjustment',
  priceAdjustmentAmount: 'priceAdjustmentAmount',
  productOptionsChangeUnitPrice: 'productOptionsChangeUnitPrice',
  configuratorSnapshotUuid: 'configuratorSnapshotUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdByServiceUuid: 'createdByServiceUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productComplexityRanking: 'productComplexityRanking',
  snapQuoteLineImportUuid: 'snapQuoteLineImportUuid'
} as const

export type SnapQuoteLineScalarFieldEnum = (typeof SnapQuoteLineScalarFieldEnum)[keyof typeof SnapQuoteLineScalarFieldEnum]


export const SnapQuotePriceScalarFieldEnum = {
  uuid: 'uuid',
  priceStrategy: 'priceStrategy',
  priceCalculationResults: 'priceCalculationResults',
  suggestedPriceStatus: 'suggestedPriceStatus',
  quantity: 'quantity',
  automatedQuantity: 'automatedQuantity',
  userQuantity: 'userQuantity',
  unitPrice: 'unitPrice',
  automatedUnitPrice: 'automatedUnitPrice',
  calculatedUnitPrice: 'calculatedUnitPrice',
  userUnitPrice: 'userUnitPrice',
  totalPrice: 'totalPrice',
  automatedUnitCost: 'automatedUnitCost',
  calculatedUnitCost: 'calculatedUnitCost',
  unitCost: 'unitCost',
  userUnitCost: 'userUnitCost',
  unitBurdenCost: 'unitBurdenCost',
  unitLaborCost: 'unitLaborCost',
  unitMaterialCost: 'unitMaterialCost',
  unitServiceCost: 'unitServiceCost',
  requiresUnsupportedCalculations: 'requiresUnsupportedCalculations',
  automatedGrossMargin: 'automatedGrossMargin',
  calculatedGrossMargin: 'calculatedGrossMargin',
  grossMargin: 'grossMargin',
  userGrossMargin: 'userGrossMargin',
  automatedBaseGrossMargin: 'automatedBaseGrossMargin',
  baseGrossMargin: 'baseGrossMargin',
  calculatedBaseGrossMargin: 'calculatedBaseGrossMargin',
  baseUnitPrice: 'baseUnitPrice',
  priceAdjustmentAmount: 'priceAdjustmentAmount',
  unitVariableCosts: 'unitVariableCosts',
  automatedContributionMargin: 'automatedContributionMargin',
  calculatedContributionMargin: 'calculatedContributionMargin',
  contributionMargin: 'contributionMargin',
  userContributionMargin: 'userContributionMargin',
  unitPriceAddition: 'unitPriceAddition',
  changesUnitPrice: 'changesUnitPrice',
  discountCode: 'discountCode',
  marketCode: 'marketCode',
  leadTimeWeeks: 'leadTimeWeeks',
  automatedLeadTimeWeeks: 'automatedLeadTimeWeeks',
  userLeadTimeWeeks: 'userLeadTimeWeeks',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdByServiceUuid: 'createdByServiceUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SnapQuotePriceScalarFieldEnum = (typeof SnapQuotePriceScalarFieldEnum)[keyof typeof SnapQuotePriceScalarFieldEnum]


export const SnapUnsupportedCalculationLogScalarFieldEnum = {
  uuid: 'uuid',
  priceStrategy: 'priceStrategy',
  requiresUnsupportedCalculations: 'requiresUnsupportedCalculations',
  createdByUserUuid: 'createdByUserUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  snapQuotePriceUuid: 'snapQuotePriceUuid',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  snapQuoteVersionUuid: 'snapQuoteVersionUuid',
  partUuid: 'partUuid'
} as const

export type SnapUnsupportedCalculationLogScalarFieldEnum = (typeof SnapUnsupportedCalculationLogScalarFieldEnum)[keyof typeof SnapUnsupportedCalculationLogScalarFieldEnum]


export const SnapWorkOrderScalarFieldEnum = {
  uuid: 'uuid',
  drawingId: 'drawingId',
  drawingRevisionNo: 'drawingRevisionNo',
  manufacturerSiteCode: 'manufacturerSiteCode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hasSubWorkOrders: 'hasSubWorkOrders',
  hasNestedRequirementWorkOrders: 'hasNestedRequirementWorkOrders',
  enableUnsupportedCalculationsFlag: 'enableUnsupportedCalculationsFlag'
} as const

export type SnapWorkOrderScalarFieldEnum = (typeof SnapWorkOrderScalarFieldEnum)[keyof typeof SnapWorkOrderScalarFieldEnum]


export const SnapOperationScalarFieldEnum = {
  uuid: 'uuid',
  sequenceNo: 'sequenceNo',
  resourceId: 'resourceId',
  vendorId: 'vendorId',
  operationType: 'operationType',
  run: 'run',
  runType: 'runType',
  loadSizeQty: 'loadSizeQty',
  setupHrs: 'setupHrs',
  setupCostPerHr: 'setupCostPerHr',
  runCostPerHr: 'runCostPerHr',
  runCostPerUnit: 'runCostPerUnit',
  serviceBaseCharge: 'serviceBaseCharge',
  serviceMinCharge: 'serviceMinCharge',
  serviceChargePerUnit: 'serviceChargePerUnit',
  serviceId: 'serviceId',
  burPerHrSetup: 'burPerHrSetup',
  burPerHrRun: 'burPerHrRun',
  burPerUnitRun: 'burPerUnitRun',
  burPercentRun: 'burPercentRun',
  burPercentSetup: 'burPercentSetup',
  burPerOperation: 'burPerOperation',
  scrapYieldPct: 'scrapYieldPct',
  scrapYieldType: 'scrapYieldType',
  fixedScrapUnits: 'fixedScrapUnits',
  snapWorkOrderUuid: 'snapWorkOrderUuid',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SnapOperationScalarFieldEnum = (typeof SnapOperationScalarFieldEnum)[keyof typeof SnapOperationScalarFieldEnum]


export const SnapRequirementScalarFieldEnum = {
  uuid: 'uuid',
  pieceNo: 'pieceNo',
  calcQty: 'calcQty',
  qtyPer: 'qtyPer',
  qtyPerType: 'qtyPerType',
  fixedQty: 'fixedQty',
  usageUnitOfMeasure: 'usageUnitOfMeasure',
  unitMaterialCost: 'unitMaterialCost',
  unitLaborCost: 'unitLaborCost',
  unitBurdenCost: 'unitBurdenCost',
  unitServiceCost: 'unitServiceCost',
  fixedCost: 'fixedCost',
  scrapPercent: 'scrapPercent',
  partUuid: 'partUuid',
  snapOperationUuid: 'snapOperationUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SnapRequirementScalarFieldEnum = (typeof SnapRequirementScalarFieldEnum)[keyof typeof SnapRequirementScalarFieldEnum]


export const PriceSegmentScalarFieldEnum = {
  uuid: 'uuid',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  segment: 'segment',
  matched: 'matched',
  priceAdjustment: 'priceAdjustment',
  resultsMetadata: 'resultsMetadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PriceSegmentScalarFieldEnum = (typeof PriceSegmentScalarFieldEnum)[keyof typeof PriceSegmentScalarFieldEnum]


export const SnapProductOptionScalarFieldEnum = {
  uuid: 'uuid',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  code: 'code',
  groupName: 'groupName',
  optionName: 'optionName',
  subOptionName: 'subOptionName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SnapProductOptionScalarFieldEnum = (typeof SnapProductOptionScalarFieldEnum)[keyof typeof SnapProductOptionScalarFieldEnum]


export const AutoConfiguratorDataImportScalarFieldEnum = {
  uuid: 'uuid',
  implementation: 'implementation',
  siteCode: 'siteCode',
  fileName: 'fileName',
  fileSizeBytes: 'fileSizeBytes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  createdByUserUuid: 'createdByUserUuid'
} as const

export type AutoConfiguratorDataImportScalarFieldEnum = (typeof AutoConfiguratorDataImportScalarFieldEnum)[keyof typeof AutoConfiguratorDataImportScalarFieldEnum]


export const AutoConfiguratorDataSetScalarFieldEnum = {
  uuid: 'uuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  data: 'data',
  dataImportUuid: 'dataImportUuid'
} as const

export type AutoConfiguratorDataSetScalarFieldEnum = (typeof AutoConfiguratorDataSetScalarFieldEnum)[keyof typeof AutoConfiguratorDataSetScalarFieldEnum]


export const AlphaQuoteScalarFieldEnum = {
  uuid: 'uuid',
  dataImportUuid: 'dataImportUuid',
  snapQuoteVersionUuid: 'snapQuoteVersionUuid',
  contactName: 'contactName',
  contactEmail: 'contactEmail',
  createdForCustomerUuid: 'createdForCustomerUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdByServiceUuid: 'createdByServiceUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AlphaQuoteScalarFieldEnum = (typeof AlphaQuoteScalarFieldEnum)[keyof typeof AlphaQuoteScalarFieldEnum]


export const AlphaQuoteLineImportScalarFieldEnum = {
  uuid: 'uuid',
  importerId: 'importerId',
  alphaQuoteUuid: 'alphaQuoteUuid',
  documentUuid: 'documentUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdByServiceUuid: 'createdByServiceUuid',
  createdAt: 'createdAt'
} as const

export type AlphaQuoteLineImportScalarFieldEnum = (typeof AlphaQuoteLineImportScalarFieldEnum)[keyof typeof AlphaQuoteLineImportScalarFieldEnum]


export const AlphaQuoteLineScalarFieldEnum = {
  uuid: 'uuid',
  status: 'status',
  evaluationStatus: 'evaluationStatus',
  syncStatus: 'syncStatus',
  calculatedDescription: 'calculatedDescription',
  description: 'description',
  descriptionIsOverridden: 'descriptionIsOverridden',
  drawingId: 'drawingId',
  drawingRevisionNo: 'drawingRevisionNo',
  notes: 'notes',
  customerPartId: 'customerPartId',
  minimumQuantity: 'minimumQuantity',
  fastenerType: 'fastenerType',
  material: 'material',
  dfars: 'dfars',
  threadSize: 'threadSize',
  threadPitch: 'threadPitch',
  length: 'length',
  shoulderDiameter: 'shoulderDiameter',
  shoulderLength: 'shoulderLength',
  headStyle: 'headStyle',
  recess: 'recess',
  serration: 'serration',
  surfaceFinish: 'surfaceFinish',
  postFinish: 'postFinish',
  sems1Style: 'sems1Style',
  sems1Weight: 'sems1Weight',
  sems2Style: 'sems2Style',
  sems2Weight: 'sems2Weight',
  osp2: 'osp2',
  osp2Description: 'osp2Description',
  osp2UOM: 'osp2UOM',
  osp2MinLot: 'osp2MinLot',
  osp3: 'osp3',
  osp3Description: 'osp3Description',
  osp3UOM: 'osp3UOM',
  osp3MinLot: 'osp3MinLot',
  toolingNote: 'toolingNote',
  headingNote: 'headingNote',
  trimmingNote: 'trimmingNote',
  pinchNote: 'pinchNote',
  rollingNote: 'rollingNote',
  shankSlottingNote: 'shankSlottingNote',
  sawSlottingNote: 'sawSlottingNote',
  dephosNote: 'dephosNote',
  heatTreatNote: 'heatTreatNote',
  surfaceFinishNote: 'surfaceFinishNote',
  postFinishNote: 'postFinishNote',
  osp2Note: 'osp2Note',
  osp3Note: 'osp3Note',
  baseMaterial: 'baseMaterial',
  thread: 'thread',
  dimensionUnit: 'dimensionUnit',
  convertedLength: 'convertedLength',
  convertedShoulderDiameter: 'convertedShoulderDiameter',
  convertedShoulderLength: 'convertedShoulderLength',
  preTrimHeadVolume: 'preTrimHeadVolume',
  finalHeadVolume: 'finalHeadVolume',
  shoulderVolume: 'shoulderVolume',
  threadVolume: 'threadVolume',
  preTrimVolume: 'preTrimVolume',
  finalVolume: 'finalVolume',
  preTrimWeight: 'preTrimWeight',
  finalWeight: 'finalWeight',
  rawMaterialSize: 'rawMaterialSize',
  cutoffLength: 'cutoffLength',
  diametersInHead: 'diametersInHead',
  threadBlankDiameter: 'threadBlankDiameter',
  reductionInArea: 'reductionInArea',
  toolingOperation: 'toolingOperation',
  headingOperation: 'headingOperation',
  headingRate: 'headingRate',
  headingSetupHours: 'headingSetupHours',
  headingSetupCost: 'headingSetupCost',
  headingSetupLabor: 'headingSetupLabor',
  headingSetupBurden: 'headingSetupBurden',
  headingSetupLaborCost: 'headingSetupLaborCost',
  headingSetupBurdenCost: 'headingSetupBurdenCost',
  headingRunLabor: 'headingRunLabor',
  headingRunBurden: 'headingRunBurden',
  pinchOperation: 'pinchOperation',
  pinchRate: 'pinchRate',
  pinchSetupHours: 'pinchSetupHours',
  pinchSetupCost: 'pinchSetupCost',
  pinchSetupLaborCost: 'pinchSetupLaborCost',
  pinchSetupBurdenCost: 'pinchSetupBurdenCost',
  pinchSetupLabor: 'pinchSetupLabor',
  pinchSetupBurden: 'pinchSetupBurden',
  pinchRunLabor: 'pinchRunLabor',
  pinchRunBurden: 'pinchRunBurden',
  rollingOperation: 'rollingOperation',
  rollingRate: 'rollingRate',
  rollingSetupHours: 'rollingSetupHours',
  rollingSetupCost: 'rollingSetupCost',
  rollingSetupLaborCost: 'rollingSetupLaborCost',
  rollingSetupBurdenCost: 'rollingSetupBurdenCost',
  rollingSetupLabor: 'rollingSetupLabor',
  rollingSetupBurden: 'rollingSetupBurden',
  rollingRunLabor: 'rollingRunLabor',
  rollingRunBurden: 'rollingRunBurden',
  trimmingOperation: 'trimmingOperation',
  trimmingRate: 'trimmingRate',
  trimmingSetupHours: 'trimmingSetupHours',
  trimmingSetupCost: 'trimmingSetupCost',
  trimmingSetupLaborCost: 'trimmingSetupLaborCost',
  trimmingSetupBurdenCost: 'trimmingSetupBurdenCost',
  trimmingSetupLabor: 'trimmingSetupLabor',
  trimmingSetupBurden: 'trimmingSetupBurden',
  trimmingRunLabor: 'trimmingRunLabor',
  trimmingRunBurden: 'trimmingRunBurden',
  shankSlottingOperation: 'shankSlottingOperation',
  shankSlottingRate: 'shankSlottingRate',
  shankSlottingSetupHours: 'shankSlottingSetupHours',
  shankSlottingSetupCost: 'shankSlottingSetupCost',
  shankSlottingSetupLaborCost: 'shankSlottingSetupLaborCost',
  shankSlottingSetupBurdenCost: 'shankSlottingSetupBurdenCost',
  shankSlottingSetupLabor: 'shankSlottingSetupLabor',
  shankSlottingSetupBurden: 'shankSlottingSetupBurden',
  shankSlottingRunLabor: 'shankSlottingRunLabor',
  shankSlottingRunBurden: 'shankSlottingRunBurden',
  sawSlottingOperation: 'sawSlottingOperation',
  sawSlottingRate: 'sawSlottingRate',
  sawSlottingSetupHours: 'sawSlottingSetupHours',
  sawSlottingSetupCost: 'sawSlottingSetupCost',
  sawSlottingSetupLaborCost: 'sawSlottingSetupLaborCost',
  sawSlottingSetupBurdenCost: 'sawSlottingSetupBurdenCost',
  sawSlottingSetupLabor: 'sawSlottingSetupLabor',
  sawSlottingSetupBurden: 'sawSlottingSetupBurden',
  sawSlottingRunLabor: 'sawSlottingRunLabor',
  sawSlottingRunBurden: 'sawSlottingRunBurden',
  dephosRequired: 'dephosRequired',
  dephosServiceId: 'dephosServiceId',
  heatTreatType: 'heatTreatType',
  heatTreatServiceId: 'heatTreatServiceId',
  surfaceFinishServiceId: 'surfaceFinishServiceId',
  surfaceFinishMinLot: 'surfaceFinishMinLot',
  postFinishServiceId: 'postFinishServiceId',
  postFinishMinLot: 'postFinishMinLot',
  osp2ServiceId: 'osp2ServiceId',
  osp3ServiceId: 'osp3ServiceId',
  manufacturerMaterialId: 'manufacturerMaterialId',
  driveStyleAdder: 'driveStyleAdder',
  threadFormingAdder: 'threadFormingAdder',
  matThreadAdder: 'matThreadAdder',
  materialLeadTimeWeeks: 'materialLeadTimeWeeks',
  headingLeadTimeWeeks: 'headingLeadTimeWeeks',
  pinchPointLeadTimeWeeks: 'pinchPointLeadTimeWeeks',
  rollingLeadTimeWeeks: 'rollingLeadTimeWeeks',
  trimmingLeadTimeWeeks: 'trimmingLeadTimeWeeks',
  shankSlottingLeadTimeWeeks: 'shankSlottingLeadTimeWeeks',
  sawSlottingLeadTimeWeeks: 'sawSlottingLeadTimeWeeks',
  dephosLeadTimeWeeks: 'dephosLeadTimeWeeks',
  heatTreatLeadTimeWeeks: 'heatTreatLeadTimeWeeks',
  finishingLeadTimeWeeks: 'finishingLeadTimeWeeks',
  osp2LeadTimeWeeks: 'osp2LeadTimeWeeks',
  osp3LeadTimeWeeks: 'osp3LeadTimeWeeks',
  orderEntryLeadTimeWeeks: 'orderEntryLeadTimeWeeks',
  toolingLeadTimeWeeks: 'toolingLeadTimeWeeks',
  hasSemsEmbed: 'hasSemsEmbed',
  alphaQuoteUuid: 'alphaQuoteUuid',
  alphaQuoteLineImportUuid: 'alphaQuoteLineImportUuid',
  manufacturerSiteCode: 'manufacturerSiteCode',
  siteUuid: 'siteUuid',
  snapQuoteLineUuid: 'snapQuoteLineUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastAppliedAt: 'lastAppliedAt',
  lastApplyFailedAt: 'lastApplyFailedAt',
  createdByUserUuid: 'createdByUserUuid',
  createdByServiceUuid: 'createdByServiceUuid'
} as const

export type AlphaQuoteLineScalarFieldEnum = (typeof AlphaQuoteLineScalarFieldEnum)[keyof typeof AlphaQuoteLineScalarFieldEnum]


export const AlphaQuotePriceScalarFieldEnum = {
  uuid: 'uuid',
  evaluationStatus: 'evaluationStatus',
  quantity: 'quantity',
  sems1Cost: 'sems1Cost',
  sems2Cost: 'sems2Cost',
  osp2Price: 'osp2Price',
  osp3Price: 'osp3Price',
  userGrossMargin: 'userGrossMargin',
  grossMarginIsOverridden: 'grossMarginIsOverridden',
  userUnitPrice: 'userUnitPrice',
  unitPriceIsOverridden: 'unitPriceIsOverridden',
  userLeadTimeWeeks: 'userLeadTimeWeeks',
  leadTimeWeeksIsOverridden: 'leadTimeWeeksIsOverridden',
  totalPreTrimWeight: 'totalPreTrimWeight',
  totalFinalWeight: 'totalFinalWeight',
  headingRunHours: 'headingRunHours',
  headingLaborReduction: 'headingLaborReduction',
  headingLaborCost: 'headingLaborCost',
  headingBurdenReduction: 'headingBurdenReduction',
  headingBurdenCost: 'headingBurdenCost',
  headingCost: 'headingCost',
  pinchRunHours: 'pinchRunHours',
  pinchLaborReduction: 'pinchLaborReduction',
  pinchLaborCost: 'pinchLaborCost',
  pinchBurdenReduction: 'pinchBurdenReduction',
  pinchBurdenCost: 'pinchBurdenCost',
  pinchCost: 'pinchCost',
  rollingRunHours: 'rollingRunHours',
  rollingLaborReduction: 'rollingLaborReduction',
  rollingLaborCost: 'rollingLaborCost',
  rollingBurdenReduction: 'rollingBurdenReduction',
  rollingBurdenCost: 'rollingBurdenCost',
  rollingCost: 'rollingCost',
  trimmingRunHours: 'trimmingRunHours',
  trimmingLaborReduction: 'trimmingLaborReduction',
  trimmingLaborCost: 'trimmingLaborCost',
  trimmingBurdenReduction: 'trimmingBurdenReduction',
  trimmingBurdenCost: 'trimmingBurdenCost',
  trimmingCost: 'trimmingCost',
  shankSlottingRunHours: 'shankSlottingRunHours',
  shankSlottingLaborReduction: 'shankSlottingLaborReduction',
  shankSlottingLaborCost: 'shankSlottingLaborCost',
  shankSlottingBurdenReduction: 'shankSlottingBurdenReduction',
  shankSlottingBurdenCost: 'shankSlottingBurdenCost',
  shankSlottingCost: 'shankSlottingCost',
  sawSlottingRunHours: 'sawSlottingRunHours',
  sawSlottingLaborReduction: 'sawSlottingLaborReduction',
  sawSlottingLaborCost: 'sawSlottingLaborCost',
  sawSlottingBurdenReduction: 'sawSlottingBurdenReduction',
  sawSlottingBurdenCost: 'sawSlottingBurdenCost',
  sawSlottingCost: 'sawSlottingCost',
  dephosCost: 'dephosCost',
  heatTreatCost: 'heatTreatCost',
  materialCost: 'materialCost',
  sems1TotalCost: 'sems1TotalCost',
  sems2TotalCost: 'sems2TotalCost',
  serrationsCost: 'serrationsCost',
  postFinishCost: 'postFinishCost',
  surfaceFinishCost: 'surfaceFinishCost',
  osp2Cost: 'osp2Cost',
  osp3Cost: 'osp3Cost',
  toolingCost: 'toolingCost',
  totalCost: 'totalCost',
  unitCost: 'unitCost',
  grossMargin: 'grossMargin',
  unitPrice: 'unitPrice',
  revenue: 'revenue',
  finalGrossMargin: 'finalGrossMargin',
  calculatedGrossMargin: 'calculatedGrossMargin',
  calculatedUnitPrice: 'calculatedUnitPrice',
  leadTimeWeeks: 'leadTimeWeeks',
  calculatedLeadTimeWeeks: 'calculatedLeadTimeWeeks',
  alphaQuoteLineUuid: 'alphaQuoteLineUuid',
  snapQuotePriceUuid: 'snapQuotePriceUuid',
  createdByUserUuid: 'createdByUserUuid',
  createdByServiceUuid: 'createdByServiceUuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AlphaQuotePriceScalarFieldEnum = (typeof AlphaQuotePriceScalarFieldEnum)[keyof typeof AlphaQuotePriceScalarFieldEnum]


export const ServiceChargeScalarFieldEnum = {
  uuid: 'uuid',
  siteCode: 'siteCode',
  id: 'id',
  erpDB: 'erpDB',
  description: 'description',
  salesTaxGroupId: 'salesTaxGroupId',
  productCode: 'productCode',
  commodityCode: 'commodityCode',
  unitPrice: 'unitPrice',
  glRevenueAcctId: 'glRevenueAcctId',
  updatedByEtlAt: 'updatedByEtlAt'
} as const

export type ServiceChargeScalarFieldEnum = (typeof ServiceChargeScalarFieldEnum)[keyof typeof ServiceChargeScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

